import { Component, OnInit } from '@angular/core';
import { OperatorsService } from './operators.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/shared/user/user.service';

@Component({
  selector: 'app-operators',
  templateUrl: './operators.component.html',
  styleUrls: ['./operators.component.scss'],
})
export class OperatorsComponent implements OnInit {

  operatorsData: any[] = [];
  regionCodes: string[] = [];

  constructor(
    private operatorsService: OperatorsService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params.regionCode) {
        this.regionCodes = [].concat(params.regionCode);
      } else {
        this.regionCodes = this.userService.getRegions();
      }

      this.operatorsService.getOperators(this.regionCodes)
        .subscribe(data => {
          this.operatorsData = data;
        });
    });
  }

  getOperatorTypeLabel(type: string): string {
    const typeMap: { [key: string]: string } = {
      'Full': 'MNO',
      'Others': 'Other',
      'Affiliated': 'Affiliated licensee',
      'Regional': 'Regional operator',
      'Satellite': 'Satellite operator',
      'Wholesale_Only': 'Wholesale-only operator',
      'OP450MHZ': '450 MHz band'
    };
    return typeMap[type] || type;
  }
}
